import type { GetStaticPaths, GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

export { BlogArticlePage as default } from '@/components/pages/News/Blog/BlogId'

export const getStaticPaths: GetStaticPaths = async () => {
  const client = new NewtClient()
  const blogList = await client.fetchBlogList()
  const paths = blogList.map((item) => ({ params: { blogId: item._id } }))

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const client = new NewtClient()
  const blog = await client.fetchBlog(`${params?.blogId}`)

  return {
    props: {
      blog,
    },
  }
}
